const EVENTS = new Set(["start", "text_delta", "completed", "error"]);
const UUID = /^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/i;
const MAX_RECORD_SIZE = 128 * 1024;

export class PlaygroundStreamError extends Error {
  constructor(message, code = "stream_error") {
    super(message);
    this.code = code;
  }
}

const invalid = () => new PlaygroundStreamError("The AI response format was invalid. Start a new conversation.", "invalid_stream");

// Decode bytes separately; this parser handles arbitrary text chunk boundaries,
// CR/LF/CRLF, comments and the SSE convention of joining multiple data lines.
export function createSSEParser(onEvent) {
  let buffer = "";
  let event = "";
  let data = [];
  let size = 0;
  const line = (value) => {
    if (value === "") {
      if (data.length && EVENTS.has(event)) {
        let payload;
        try { payload = JSON.parse(data.join("\n")); } catch { throw invalid(); }
        if (!payload || typeof payload !== "object" || Array.isArray(payload)) throw invalid();
        if (event === "start" && (typeof payload.request_id !== "string" || !UUID.test(payload.conversation_id))) throw invalid();
        if (event === "text_delta" && typeof payload.text !== "string") throw invalid();
        if (event === "completed" && typeof payload.request_id !== "string") throw invalid();
        if (event === "error" && typeof payload.message !== "string") throw invalid();
        onEvent(event, payload);
      }
      event = "";
      data = [];
      size = 0;
      return;
    }
    size += value.length;
    if (size > MAX_RECORD_SIZE) throw invalid();
    if (value.startsWith(":")) return;
    const colon = value.indexOf(":");
    const field = colon < 0 ? value : value.slice(0, colon);
    let content = colon < 0 ? "" : value.slice(colon + 1);
    if (content.startsWith(" ")) content = content.slice(1);
    if (field === "event") event = content;
    if (field === "data") data.push(content);
  };
  const consume = (final = false) => {
    while (buffer.length) {
      const match = /[\r\n]/.exec(buffer);
      if (!match) break;
      const index = match.index;
      if (!final && buffer[index] === "\r" && index === buffer.length - 1) break;
      const width = buffer[index] === "\r" && buffer[index + 1] === "\n" ? 2 : 1;
      const value = buffer.slice(0, index);
      buffer = buffer.slice(index + width);
      line(value);
    }
    if (buffer.length > MAX_RECORD_SIZE) throw invalid();
  };
  return {
    push(text) { buffer += text; consume(); },
    finish() {
      consume(true);
      // EOF without a terminating blank line is an incomplete SSE record.
      if (buffer.length || data.length || event) throw invalid();
    },
  };
}
